import { useMutation } from '@tanstack/react-query';
import {
    agentRole,
  UserApiService,
} from 'features/users/api/user-api.service';

const { createAgent } = UserApiService();

export const useCreateUserAgentRole = () => {

  return useMutation(
    (payload: agentRole) => {
      return createAgent(payload);
    },
  );
};





